/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Import free gift calculator component
// import './components/free-gift-calculator.js';
var ProductItemCard = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductItemCard, _HTMLElement);
  var _super = _createSuper(ProductItemCard);
  function ProductItemCard() {
    var _this;
    _classCallCheck(this, ProductItemCard);
    _this = _super.call(this);
    _this.selectedVariant = _this.dataset.variantId;
    _this.variantsImages = _this.querySelectorAll('.product-variants-image img');
    _this.productOptions = JSON.parse(_this.dataset.productOptions).map(function (option) {
      return option.name;
    });
    _this.product = JSON.parse(_this.dataset.productVariants);
    _this.priceWrapper = _this.querySelector(".grid-product__price");
    //here i want to set some variants available false just for testing i want to make them random
    // this.product.variants.forEach(variant => {
    //     variant.available = Math.random() >= 0.5;
    // });
    return _this;
  }
  _createClass(ProductItemCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$querySelector,
        _this2 = this;
      (_this$querySelector = this.querySelector(".atc-btn")) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.addEventListener("click", function () {
        var qty = 1;
        _this2.addToCartGrid(qty);
      });
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.addEventListener("click", function () {
          _this2.getVariantBySelectedOption(el.dataset.optionName, el.dataset.optionValue);
          _this2.checkDisablitiyButtons(el.dataset.optionName, el.dataset.optionValue);
          _this2.updatePriceCurrentVariant();
          _this2.updateBuyButtonState();
          // //update image
          var imgElement = _this2.querySelector(".grid-product__image-mask img");
          _this2.variantsImages.forEach(function (image) {
            if (image.dataset.variantId === _this2.selectedVariant.toString()) {
              console.log(image.dataset.variantId, _this2.selectedVariant);
              imgElement.setAttribute("src", image.dataset.variantImage);
              imgElement.setAttribute("srcset", image.dataset.variantImageSrcset);
            }
          });
        });
      });
      //select first avaialble option
      var firstAvailableVariant = this.product.variants.find(function (variant) {
        return variant.available;
      });
      if (firstAvailableVariant) {
        this.selectedVariant = firstAvailableVariant.id;
        this.selectVariantSelectionByOption(firstAvailableVariant.options);
        this.checkDisablitiyButtons(this.productOptions[0], firstAvailableVariant.options[0]);
        this.updatePriceCurrentVariant();
        this.updateBuyButtonState();
      } else {
        this.querySelectorAll(".trigger-update-variant").forEach(function (button) {
          return button.setAttribute("disabled", "true");
        });
        this.updateBuyButtonState();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$querySelector2,
        _this3 = this;
      (_this$querySelector2 = this.querySelector(".atc-btn")) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.removeEventListener("click", this.addToCartGrid);
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.removeEventListener("click", _this3.getVariantBySelectedOption);
      });
    }
  }, {
    key: "updatePriceCurrentVariant",
    value: function updatePriceCurrentVariant() {
      var _this4 = this;
      //update price
      if (this.selectedVariant) {
        var variant = this.product.variants.find(function (variant) {
          return variant.id === _this4.selectedVariant;
        });
        this.priceWrapper.innerHTML = "<span class=\"grid-product__price\" ".concat(variant.compare_at_price > variant.price ? "style=\"color:var(--colorSaleTag);\"" : "", ">").concat(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat), "</span> ").concat(variant.compare_at_price > variant.price ? "<span class=\"grid-product__price--original\">".concat(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat), "</span><span class=\"grid-product__price--saved\">(Save ").concat(theme.Currency.formatMoney(variant.compare_at_price - variant.price, theme.settings.moneyFormat), ")</span><span class=\"grid-product__price--percentage\">(").concat(Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100), "% Off)</span>") : "");
      }
    }
  }, {
    key: "updateBuyButtonState",
    value: function updateBuyButtonState() {
      var _this5 = this;
      var variant = this.product.variants.find(function (variant) {
        return variant.id === _this5.selectedVariant;
      });
      var atcButton = this.querySelector(".atc-btn");
      var soldOutLabel = this.querySelector(".soldout");
      if (variant && variant.available) {
        atcButton.classList.remove("hide");
        soldOutLabel.classList.add("hide");
      } else {
        atcButton.classList.add("hide");
        soldOutLabel.classList.remove("hide");
      }
    }
  }, {
    key: "addToCartGrid",
    value: function addToCartGrid(qty) {
      var id = this.selectedVariant;
      var q = qty;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function success(n) {
          var cart = new theme.CartDrawer();
          cart.init();
          cart.open();
        },
        error: function error(n, c) {
          console.log("fail");
        }
      };
      jQuery.ajax(ajax);
    }
  }, {
    key: "getVariantBySelectedOption",
    value: function getVariantBySelectedOption(optionName, optionValue) {
      var _this6 = this;
      var optionIndex = this.productOptions.findIndex(function (option) {
        return option.toLowerCase() === optionName.toLowerCase();
      });
      if (optionIndex === -1) {
        console.error("Option name \"".concat(optionName, "\" not found in product options."));
        return;
      }

      // Get the current options of the selected variant
      var currentOptions = this.product.variants.find(function (variant) {
        return variant.id === _this6.selectedVariant;
      }).options.slice();

      // Update only the selected option value
      currentOptions[optionIndex] = optionValue;

      // Find the variant that matches the updated options
      var selectedVariant = this.product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option.toLowerCase() === currentOptions[index].toLowerCase();
        });
      });
      if (selectedVariant) {
        this.selectedVariant = selectedVariant.id;
        this.selectVariantSelectionByOption(selectedVariant.options);
      }

      // i want to update the quantity for the other options
      // Check and update the availability of other options
      this.productOptions.forEach(function (option, index) {
        if (index !== optionIndex) {
          var optionValues = new Set(_this6.product.variants.filter(function (variant) {
            return variant.options[optionIndex].toLowerCase() === optionValue.toLowerCase();
          }).map(function (variant) {
            return variant.options[index].toLowerCase();
          }));
          _this6.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(option, "\"]")).forEach(function (button) {
            if (optionValues.has(button.dataset.optionValue.toLowerCase())) {
              button.removeAttribute("disabled");
            } else {
              button.setAttribute("disabled", "true");
            }
          });
        }
      });
    }
  }, {
    key: "selectVariantSelectionByOption",
    value: function selectVariantSelectionByOption(optionValues) {
      var _this7 = this;
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.classList.remove("selected-btn");
      });
      var buttons = this.querySelectorAll(".trigger-update-variant");
      optionValues.forEach(function (value, index) {
        var buttonsWithValues = Array.from(buttons).filter(function (button) {
          return button.dataset.optionName.toLowerCase() === _this7.productOptions[index].toLowerCase() && button.dataset.optionValue.toLowerCase() === value.toLowerCase();
        });
        buttonsWithValues.forEach(function (button) {
          return button.classList.add("selected-btn");
        });
      });
    }
  }, {
    key: "checkDisablitiyButtons",
    value: function checkDisablitiyButtons(optionName, optionValue) {
      var _this8 = this;
      if (this.productOptions.length === 1) {
        var availableOptions = this.product.variants.filter(function (variant) {
          return variant.available;
        }).map(function (variant) {
          return variant.options[0];
        });
        this.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(optionName.toLowerCase(), "\"]")).forEach(function (button) {
          if (availableOptions.includes(button.dataset.optionValue)) {
            button.removeAttribute("disabled");
          } else {
            button.setAttribute("disabled", "true");
          }
        });
      } else {
        var selectedOptionIndex = this.productOptions.findIndex(function (option) {
          return option.toLowerCase() === optionName.toLowerCase();
        });
        var selectedOptionValues = this.product.variants.filter(function (variant) {
          return variant.options[selectedOptionIndex].toLowerCase() === optionValue.toLowerCase() && variant.available;
        }).map(function (variant) {
          return variant.options;
        });
        this.productOptions.forEach(function (option, index) {
          if (index !== selectedOptionIndex) {
            var availableValues = new Set(selectedOptionValues.map(function (values) {
              return values[index].toLowerCase();
            }));
            _this8.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(option.toLowerCase(), "\"]")).forEach(function (button) {
              if (availableValues.has(button.dataset.optionValue.toLowerCase())) {
                button.removeAttribute("disabled");
              } else {
                button.setAttribute("disabled", "true");
              }
              // Update image based on the current options
              var variantImage = Array.from(_this8.variantsImages).find(function (image) {
                var imageOptions = JSON.parse(image.dataset.variantOptions);
                return imageOptions.some(function (option) {
                  return option.toLowerCase() === optionValue.toLowerCase() && imageOptions.map(function (opt) {
                    return opt.toLowerCase();
                  }).includes(button.dataset.optionValue.toLowerCase());
                });
              });
              if (variantImage) {
                button.dataset.variantImage = variantImage.dataset.variantImage;
                button.dataset.variantImageSrcset = variantImage.dataset.variantImageSrcset;
                if (button.dataset.optionName.toLowerCase() === 'color') {
                  button.style.backgroundImage = "url(".concat(variantImage.dataset.variantImage, ")");
                }
              }
            });
          }
        });
      }
    }
  }]);
  return ProductItemCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("product-item-card", ProductItemCard);

//product slider
// Define a class for the Swiper component that extends the HTMLElement class
var PrototypeSlider = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PrototypeSlider, _HTMLElement2);
  var _super2 = _createSuper(PrototypeSlider);
  // The constructor is called when an object is created with the class
  function PrototypeSlider() {
    var _this9;
    _classCallCheck(this, PrototypeSlider);
    _this9 = _super2.call(this); // Call the parent class constructor
    _this9.slideDesktop = _this9.dataset.slideDesktop;
    _this9.slideMobile = _this9.dataset.slideMobile;
    return _this9;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  _createClass(PrototypeSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initSwiper(); // Initialize the Swiper when the component is connected

      // Add event listeners
      document.addEventListener('shopify:section:load', this.initSwiper);
      document.addEventListener('shopify:section:reorder', this.initSwiper);
      document.addEventListener('shopify:section:select', this.initSwiper);
      document.addEventListener('shopify:block:select', this.initSwiper);
    }

    // Method to initialize the Swiper
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      // Define the options for the Swiper
      var calculateSpaceBetween = function calculateSpaceBetween(slidesPerView) {
        if (slidesPerView < 2) return 80;
        if (slidesPerView >= 2 && slidesPerView <= 4) return 60;
        return 40;
      };
      var swiperOptions = {
        slidesPerView: this.slideMobile,
        // Number of slides per view
        spaceBetween: calculateSpaceBetween(this.slideMobile),
        // Space between slides
        breakpoints: {
          // Breakpoints for different screen widths
          768: {
            slidesPerView: this.slideDesktop,
            spaceBetween: calculateSpaceBetween(this.slideDesktop)
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };

      // Initialize the Swiper with the options
      new Swiper(this, swiperOptions);
    }
  }]);
  return PrototypeSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("prototype-slider", PrototypeSlider);

// Add variant swatch observer for PDP page
var VariantSwatchObserver = /*#__PURE__*/function () {
  function VariantSwatchObserver() {
    _classCallCheck(this, VariantSwatchObserver);
    this.init();
  }
  _createClass(VariantSwatchObserver, [{
    key: "init",
    value: function init() {
      var _this10 = this;
      // Watch for changes to the DOM to catch when variant swatches are added
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            _this10.setupSwatchListeners();
          }
        });
      });

      // Start observing the document body
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Try to set up listeners immediately in case swatches are already on the page
      this.setupSwatchListeners();
    }
  }, {
    key: "setupSwatchListeners",
    value: function setupSwatchListeners() {
      var _this11 = this;
      // Find all variant-swatch-king elements
      var swatchContainers = document.querySelectorAll('.page-content--product variant-swatch-king');
      if (swatchContainers.length > 0) {
        console.log('Found variant swatch containers:', swatchContainers.length);
        swatchContainers.forEach(function (container) {
          // Find all swatch items within each container
          var swatchItems = container.querySelectorAll('.swatch-view-item');
          swatchItems.forEach(function (item) {
            // Remove existing listeners to avoid duplicates
            item.removeEventListener('click', _this11.handleSwatchClick);
            // Add click event listener
            item.addEventListener('click', _this11.handleSwatchClick);
          });
        });
      }
    }
  }, {
    key: "handleSwatchClick",
    value: function handleSwatchClick(event) {
      var swatchItem = event.currentTarget;
      var backInstockButton = document.querySelector('.klaviyo-bis-trigger');
      if (backInstockButton && swatchItem && swatchItem.classList.contains('swatch-item-unavailable')) {
        // If the swatch is unavailable, show the back in stock button
        backInstockButton.classList.remove('hidden');
      } else {
        // If the swatch is available, hide the back in stock button
        backInstockButton.classList.add('hidden');
      }
    }
  }]);
  return VariantSwatchObserver;
}(); // Initialize the variant swatch observer
document.addEventListener('DOMContentLoaded', function () {
  new VariantSwatchObserver();

  // Initialize free gift calculator if it exists
  if (window.CustomComponents && window.CustomComponents.FreeGiftCalculator) {
    window.CustomComponents.FreeGiftCalculator.init();
  }
});

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgrayl"] = self["webpackChunkgrayl"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;